import { SyncOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";

interface SyncButtonProps {
  loading: boolean;
  onSync: () => void;
}

const SyncButton = ({ loading, onSync }: SyncButtonProps) => (
  <Tooltip
    title={
      <div>
        <strong>Sync Users</strong> pulls the latest people from Azure AD
        (Microsoft Entra) into the project team. Anyone new is added with no
        role and appears highlighted in green — switch to the{" "}
        <strong>New</strong> tab and edit each one to assign a role. Existing
        members whose details changed are highlighted in yellow.
      </div>
    }
  >
    <Button
      type="primary"
      size="large"
      icon={<SyncOutlined />}
      loading={loading}
      onClick={onSync}
    >
      Sync Users
    </Button>
  </Tooltip>
);

export default SyncButton;
